"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const default_session_1 = require("../../../../session/default-session");
const curves_provider_1 = require("../curves-provider");
function Definition(params, outputs) {
    let parameters;
    if (Array.isArray(params)) {
        parameters = {
            universe: params,
            outputs,
        };
    }
    else {
        parameters = params;
    }
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const curvesProvider = new curves_provider_1.CurvesProvider(session);
            return curvesProvider.getZcCurves(parameters);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9jdXJ2ZXMvemMtY3VydmVzL2RlZmluaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EseUVBQWlFO0FBQ2pFLHdEQUFvRDtBQUlwRCxTQUFnQixVQUFVLENBQ3RCLE1BQTZGLEVBQzdGLE9BQWtCO0lBRWxCLElBQUksVUFBc0MsQ0FBQztJQUUzQyxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQztRQUN4QixVQUFVLEdBQUc7WUFDVCxRQUFRLEVBQUUsTUFBTTtZQUNoQixPQUFPO1NBQ1YsQ0FBQztJQUNOLENBQUM7U0FBTSxDQUFDO1FBQ0osVUFBVSxHQUFHLE1BQU0sQ0FBQztJQUN4QixDQUFDO0lBRUQsT0FBTztRQUNILE9BQU8sQ0FBQyxVQUFtQixJQUFBLDRCQUFVLEdBQUU7WUFDbkMsTUFBTSxjQUFjLEdBQUcsSUFBSSxnQ0FBYyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBQ25ELE9BQU8sY0FBYyxDQUFDLFdBQVcsQ0FBQyxVQUFVLENBQUMsQ0FBQztRQUNsRCxDQUFDO0tBQ0osQ0FBQztBQUNOLENBQUM7QUFyQkQsZ0NBcUJDIn0=